var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.72d001720746dfd15326067ca957ddb1.svg#Q';
                    var viewUrl = 'sprites.72d001720746dfd15326067ca957ddb1.svg#view-Q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 2110 359.6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };